var SVGO = require('svgo');
/**
 * Cleans the given svg as string and returns its cleaned version.
 * This function will transform all shapes into pathes and apply all
 * transformations to pathes to reduce the size of the output. All the
 * useless entries will be removed and all elements will be flatten if
 * possible.
 *
 * @param svgData The initial svg content
 */
export var cleanSvg = function (svgData) {
    var svgoObj = new SVGO({
        full: true,
        plugins: [{
                cleanupAttrs: true,
            }, {
                removeDoctype: true,
            }, {
                removeXMLProcInst: true,
            }, {
                removeComments: true,
            }, {
                removeMetadata: true,
            }, {
                removeTitle: true,
            }, {
                removeDesc: true,
            }, {
                removeUselessDefs: true,
            }, {
                removeEditorsNSData: true,
            }, {
                removeEmptyAttrs: true,
            }, {
                removeHiddenElems: true,
            }, {
                removeEmptyText: true,
            }, {
                removeEmptyContainers: true,
            }, {
                removeViewBox: false,
            }, {
                convertStyleToAttrs: true,
            }, {
                convertColors: true,
            }, {
                convertPathData: true,
            }, {
                convertTransform: true,
            }, {
                removeUnknownsAndDefaults: true,
            }, {
                removeNonInheritableGroupAttrs: true,
            }, {
                removeUselessStrokeAndFill: true,
            }, {
                removeUnusedNS: true,
            }, {
                cleanupIDs: true,
            }, {
                cleanupNumericValues: true,
            }, {
                moveElemsAttrsToGroup: true,
            }, {
                moveGroupAttrsToElems: true,
            }, {
                collapseGroups: true,
            }, {
                removeRasterImages: false,
            }, {
                mergePaths: true,
            }, {
                convertShapeToPath: {
                    convertArcs: true
                }
            }, {
                sortAttrs: true,
            }, {
                removeDimensions: true,
            }]
    });
    return svgoObj.optimize(svgData);
};
